var styleDataHash = "76046322";
const injectCss = () => {
  var css = `.eVTg5{align-items:center;color:#fff;display:flex;height:100%;justify-content:center;position:absolute;top:0;width:100%}[dir] .eVTg5{background:rgba(0,0,0,.5);text-align:center}.Y0F2w{height:20px;width:20px}[dir] .S8uqa{margin-bottom:56px}.sSa-3{font-size:16px;line-height:24px;position:absolute}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var media_item_error_msg_default = {
  "error": "eVTg5",
  "errorIcon": "Y0F2w",
  "errorIconWithMessage": "S8uqa",
  "errorMsg": "sSa-3"
};
export {
  media_item_error_msg_default as default,
  injectCss
};
//# sourceMappingURL=media-item-error-msg-scss.js.map
